import React, { Component } from 'react';
import { connect } from 'react-redux';

import { FormattedMessage } from 'react-intl';

import { ReactComponent as InfantIcon } from '../../svg/infant.svg';
import { ReactComponent as HopperInfantIcon } from '../../svg/hopper-infant.svg';
import { GenericDetails } from './templates/GenericDetails';

export class InfantDetails extends Component {
  render() {
    const {
      selectedSeat,
      passengers = {},
      parentHeight,
      position,
      variants,
    } = this.props;
    const { currentPassenger = {} } = passengers;
    const passengerIsInfant = currentPassenger.type === 'infant';
    const passengerHasInfantOnLap = currentPassenger.infant_on_lap;
    const { test_hopper_loader = false } = variants;

    const infantIcon = test_hopper_loader ? (
      <HopperInfantIcon id="hopper-infant-bunny" />
    ) : (
      <InfantIcon />
    );

    const infantPrimary = (
      <>
        {passengerIsInfant &&
          currentPassenger.first_names + ' ' + currentPassenger.surname}
        {passengerHasInfantOnLap && (
          <FormattedMessage
            id="infant_on_lap_header"
            defaultMessage="Seat will be shared with an infant"
          />
        )}
      </>
    );

    const infantSecondary = (
      <>
        {passengerIsInfant && (
          <FormattedMessage
            id="infants_next_to_adults"
            defaultMessage="Infants must be seated next to an adult"
          />
        )}
        {passengerHasInfantOnLap && (
          <FormattedMessage
            id="infant_on_lap_content"
            defaultMessage="You are selecting a seat that will have an infant on lap with you"
          />
        )}
      </>
    );

    if ((passengerIsInfant || passengerHasInfantOnLap) && !selectedSeat) {
      return (
        <GenericDetails
          parentHeight={parentHeight}
          position={position}
          primary={infantPrimary}
          secondary={infantSecondary}
          popupIcon={infantIcon}
          idPrefix="infant"
          mobile={true}
        />
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => ({
  parentHeight: state.session.parentHeight,
  passengers: state.passengers,
  selectedSeat: state.selectedSeat,
  variants: state.session.variants,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(InfantDetails);
